export const lang = {
  ko: {
    headerTitle: '정보대학(학부) 챗봇 호빗',
    questionLabel: '질문:',
    answerLabel: '답변:',
    managerContact: '담당자 연락처:',
    recommendKeywords: '추천 키워드',
    backToHome: '처음으로',
    admin: '행정',
    life: '생활',
    faq: '자주 묻는 질문',
  },
  en: {
    headerTitle: 'Info Chatbot hoBIT',
    questionLabel: 'Question:',
    answerLabel: 'Answer:',
    managerContact: 'Manager Contact:',
    recommendKeywords: 'Recommended Keywords',
    backToHome: 'Back to Home',
    admin: 'Admin',
    life: 'Lifestyle',
    faq: 'Frequently Asked Questions',
  },
};
